module.exports = __webpack_public_path__ + "static/sharing-9867182b8582170b89dc94be71147b9f.jpg";